/* State client data model
 *
 * trackerbase.models.State
 */

import Recipient from "./Recipient";

import makePropsEnumerable from "../utility/MakePropsEnumerable";
import SortAsComparer from "tbClient/utility/SortAsComparer";

class State {
    constructor(
        stateId,
        stateShortName,
        stateFullName,
        isUSState,
        isRealPlace,
        stateOffices,
        stateOfficeSubscribers,
        stateEventSubscribers
    )
    {
        if (Number.isInteger(stateId))
        {
            this.stateId = stateId;
        }
        else {
            throw new TypeError("Invalid or missing state id");
        }

        if ((stateShortName != null) &&
            (angular.isString(stateShortName)) &&
            (stateShortName.length === 2))
        {
            this.shortName = stateShortName;
        }
        else {
            throw new TypeError("Invalid or missing state abbreviation");
        }

        if ((stateFullName != null) &&
            (angular.isString(stateFullName)) &&
            (stateFullName.length > 0))
        {
            this.fullName = stateFullName;
        }
        else {
            throw new TypeError("Invalid or missing state full name");
        }

        if ((isUSState != null) &&
            (typeof(isUSState) === "boolean"))
        {
            this.isUSState = isUSState;
        }
        else {
            throw new TypeError("Invalid or missing Is-US-State value");
        }

        if ((isRealPlace != null) &&
            (typeof(isRealPlace) === "boolean"))
        {
            this.isRealPlace = isRealPlace;
        }
        else {
            throw new TypeError("Invalid or missing Is-US-State value");
        }

        this.stateOffices = [];
        if ((stateOffices != null) &&
            (angular.isArray(stateOffices)))
        {
            Array.prototype.push.apply(this.stateOffices, stateOffices);
        }

        this.stateOfficeSubscribers = [];
        if ((stateOfficeSubscribers != null) && 
            (angular.isArray(stateOfficeSubscribers)))
        {
            Array.prototype.push.apply(this.stateOfficeSubscribers, stateOfficeSubscribers);
        }

        this.stateEventSubscribers = [];
        if ((stateEventSubscribers != null) && 
            (angular.isArray(stateEventSubscribers)))
        {
            Array.prototype.push.apply(this.stateEventSubscribers, stateEventSubscribers);
        }

    }

    isActualState() {
        return this.isUSState;
    }

    isRealState() {
        return this.isRealPlace;
    }

    isConceptualState() {
        return !this.isRealPlace;
    }

    toString() {
        return `${this.fullName}/${this.shortName}/${this.stateId}`;
    }

    valueOf() {
        return this.stateId;
    }

    get stateName() {
        return this.fullName;
    }

    get displayName() {
        return this.stateName;
    }

    get sortAs() {
        return this.stateName;
    }

    get subscribableId() {
        return this.stateId;
    }

    static CopyState(otherState) {
        return new State(
            otherState.stateId,
            otherState.shortName,
            otherState.fullName,
            otherState.isUSState,
            otherState.isRealPlace,
            angular.copy(otherState.stateOffices),
            angular.copy(otherState.stateOfficeSubscribers),
            angular.copy(otherState.stateEventSubscribers)
        );
    }

    static FromServerState(serverState, officeServerFactoryFn) {
        var receivedStateId = null;
        if ((serverState["StateId"] !== undefined) &&
            (serverState["StateId"] != null))
        {
            receivedStateId = serverState.StateId;
        } else {
            throw new TypeError("Null or missing state id.");
        }

        var isState = false;
        if (serverState["IsActualState"] === true)
        {
            isState = true;
        }

        var isRealPlace = false;
        if (serverState["IsRealPlace"] === true) {
            isRealPlace = true;
        }

        var stateOfficeData = undefined;
        if (angular.isDefined(officeServerFactoryFn)) {
            if ((angular.isDefined(serverState.StateOffices)) &&
                (serverState.StateOffices != null)) {
                stateOfficeData = serverState.StateOffices.map(function(so) {
                    return officeServerFactoryFn(so);
                });
                stateOfficeData.sort(SortAsComparer);
            }
        }

        var stateOfficeSubscriberData = undefined;
        if ((angular.isDefined(serverState.StateOfficeSubscribers)) &&
            (serverState.StateOfficeSubscribers != null))
        {
            stateOfficeSubscriberData = serverState.StateOfficeSubscribers.map(function(soSub) {
                return Recipient.FromServerRecipient(soSub);
            });
        }

        var stateEventSubscriberData = undefined;
        if ((angular.isDefined(serverState.StateEventSubscribers)) &&
            (serverState.StateEventSubscribers != null))
        {
            stateEventSubscriberData = serverState.StateEventSubscribers.map(function(seSub) {
                return Recipient.FromServerRecipient(seSub);
            });
        }

        return new State(
            receivedStateId,
            serverState.ShortName,
            serverState.Name,
            isState,
            isRealPlace,
            stateOfficeData,
            stateOfficeSubscriberData,
            stateEventSubscriberData
        );
    }

}

makePropsEnumerable(State.prototype, [
    "isActualState",
    "isRealState",
    "isConceptualState",
    "stateName",
    "displayName",
    "sortAs",
    "subscribableId"
]);

export default State;



//////////////////
// WEBPACK FOOTER
// ./src/models/State.js
// module id = s+SI
// module chunks = 1